import { render, staticRenderFns } from "./Kilometraje.vue?vue&type=template&id=4d830f20&"
import script from "./Kilometraje.vue?vue&type=script&lang=js&"
export * from "./Kilometraje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports